import styled from "styled-components";
import { PRIMARY } from "../../const/colors";

export const Container = styled.div`
  width: 100vw;
  margin: 0 auto;
  // padding: 0 8%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
	max-width: 2200px;
	@media screen and (max-width: 1200px) {
		padding: 0;
	}
	@media screen and (max-width: 1080px) {
		margin-top: 4rem;
	}
	@media screen and (max-width: 768px) {
		margin-top: 4rem;
	}
`;

export const Wrapper = styled.div`
  /* height: 300px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // border-top: 1px solid ${PRIMARY};
  > div {
    width: 100%;
  }
`;

export const LineSeparator = styled.div`
  max-height: 1px !important;
  margin: 1rem 0;
  width: 100% !important;
  background-color: ${PRIMARY};
`;

export const WrapperCategories = styled.div`
  margin-bottom: 100px;
  @media screen and (max-width: 768px) {
    padding: 0 15%;
    margin-bottom: 50px;
  }
  ul.slick-dots {
    display: none !important;
  }
`;

export const BannerDesktop = styled.div`
  position: relative;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const BannerMobile = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const SeoP = styled.p`
  font-size: 0.9rem;
  color: #777;
  font-weight: 400;
  width: 90%;
  text-align: center;
  margin-bottom: 2rem;
  @media screen and (max-width: 768px) {
    width: 100%;
    font-size: 0.6rem;
    padding: 2rem 0.25rem;
    margin-bottom: 0;
  }
`;
// **************************************** style de angel ****************************************

export const SubContainer = styled.section`
  padding: 0 8%;
  @media screen and (max-width: 768px) {
    padding: 0 10px;
  }
`;
export const TitleText = styled.div`
  overflow: hidden;
  height: 100%;
  min-height: 420px;
  & span.title {
    position: relative;
    font-size: 2.2rem;
    color: rgb(255, 255, 255);
    margin-bottom: 1rem;
    font-weight: 800;
    display: inline-block;
  }
  & span.title::after {
    content: "";
    height: 2px;
    background: ${PRIMARY};
    position: absolute;
    left: 0;
    right: 0;
    bottom: -6px;
    opacity: 0;
    transform-origin: left center;
    transition: all 0.25s cubic-bezier(0.25, 0.43, 0.45, 0.94) 0s;
    transform: scaleX(0);
  }
  &:hover {
    span.title:after {
      transform: scaleX(1);
      opacity: 1;
    }
  }
  @media screen and (max-width: 768px) {
    padding: 30px 0 0 0;
    min-height: 300px;
    overflow: initial;
    & span.title {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
      display: block;
    }
  }
`;
